import { render, staticRenderFns } from "./ServiceActionsForm.vue?vue&type=template&id=54545894"
import script from "./ServiceActionsForm.vue?vue&type=script&lang=js"
export * from "./ServiceActionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports